import { useState, useEffect } from 'react';

const ROTATION_INTERVAL_MS = 5000;

type SearchTipsResponse = {
    tips?: unknown;
};

export function useSearchHotKeywords(locationId?: number): string {
    const [keywords, setKeywords] = useState<string[]>([]);
    const [index, setIndex] = useState(0);

    useEffect(() => {
        let active = true;

        setKeywords([]);
        setIndex(0);

        if (locationId === undefined) {
            return () => {
                active = false;
            };
        }

        const loadKeywords = async () => {
            try {
                const response = await fetch(
                    `/api/search-tips?locationId=${encodeURIComponent(locationId)}`,
                    {
                        credentials: 'include',
                        headers: { Accept: 'application/json' },
                    }
                );

                if (!response.ok) return;

                const data = (await response.json()) as SearchTipsResponse;
                if (!Array.isArray(data.tips)) return;

                const tips = data.tips.filter(
                    (tip): tip is string => typeof tip === 'string' && tip.length > 0
                );
                if (active) setKeywords(tips);
            } catch {
                // Keep the default search placeholder when recommendations are unavailable.
            }
        };

        void loadKeywords();

        return () => {
            active = false;
        };
    }, [locationId]);

    useEffect(() => {
        if (keywords.length < 2) return undefined;

        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % keywords.length);
        }, ROTATION_INTERVAL_MS);

        return () => clearInterval(interval);
    }, [keywords]);

    return keywords[index] || '';
}
